/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState, useEffect } from 'react';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Chart from 'react-apexcharts';
import 'react-image-lightbox/style.css';
import { withTranslation } from 'react-i18next';
import moment from 'moment';
import toastr from 'toastr';

import {
  Card, CardBody, CardHeader,
  Col, Row,
} from 'reactstrap';

import { get } from '../../helpers/api_helper';

function Usage(props) {
  const { t, item } = props;

  const [data, setData] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await get(`/api/items/reports/${item.id}/usage`);

        setData(response);
      } catch (error) {
        toastr.error(t('Error fetching usage data'));
      }
    };

    fetchData();
  }, [item.id]); // Depend on item.id to refetch when item changes

  const jsx = (
    <div>
      {data !== null && data.latest && (
      <Card>
        <CardHeader className="bg-transparent border-bottom">
          {t('In-Stock Usage Stats')}
        </CardHeader>
        <CardBody className="p-3 pt-1">
          <div>
            <Row>
              <Col sm="6">
                <h1 style={{ fontSize: '28px' }}>
                  <span style={{ fontSize: '11px' }}>{t('Avg')}</span>
                  {' '}
                  <span>{data.avg && data.avg.toFixed(1)}</span>
                </h1>
                <span style={{ fontSize: '11px' }}>{`${data.latest !== undefined && data.latest.out_at === null ? `${t('Stock since')}: ${moment(data.latest.in_at).fromNow()}` : `OOS since: ${moment(data.latest.out_at).fromNow()}`}`}</span>
              </Col>
              <Col sm="6" className="text-end">
                <h1 style={{ fontSize: '22px' }} className="text-muted mb-0">
                  <span style={{ fontSize: '11px' }}>{t('Latest')}</span>
                  {' '}
                  <span className="text-success">{data.latest !== undefined && data.latest.thirty_rate && data.latest.thirty_rate.toFixed(1)}</span>
                  <br />
                  <span style={{ fontSize: '10px' }}>{t('Uses')}</span>
                  {' '}
                  <span>{data.latest && data.latest.used_qty}</span>
                  {data.latest !== undefined && data.latest.thirty_rate
                    && item.qty / (data.latest.thirty_rate / 30) > 0 && (
                    <div>
                      {' '}
                      <span style={{ fontSize: '10px' }}>{(item.qty / (data.latest.thirty_rate / 30)).toFixed(1)}</span>
                      {' '}
                      <span style={{ fontSize: '10px' }}>{t('days worth of qty')}</span>
                    </div>
                  )}
                </h1>
              </Col>
            </Row>
          </div>
        </CardBody>
      </Card>
      )}
    </div>
  );

  return jsx;
}

Usage.propTypes = {
  // eslint-disable-next-line react/require-default-props
  t: PropTypes.any,
  item: PropTypes.object.isRequired,
};

export default connect(() => ({

}), {})(withTranslation()(Usage));
